const PHONE_NUMBER: string = '8 (3852) 505-065'
const ERROR_PHONE_NUMBER: string = '8 (3852) 505-065'

export {PHONE_NUMBER, ERROR_PHONE_NUMBER}
